'use strict';

var FaresOptimizerAnalysisToolbarDirective = function FaresOptimizerAnalysisToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerAnalysisToolbarController',
    template: require('../templates/fares-optimizer-analysis-toolbar.html'),
    scope: {
      screenState: '='
    }
  };
};
FaresOptimizerAnalysisToolbarDirective.$inject = [];
module.exports = FaresOptimizerAnalysisToolbarDirective;